import { faSyringe } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { PetVaccineOption } from 'components/Pet/Form/Vaccines/Option/PetVaccineOption';
import { useMarketplace } from 'hooks/useMarketplace';
import React from 'react';
import { Option } from 'types/Generics';
import { createEmptyVaccine, PetVaccine } from 'types/Pet';

import classes from './PetVaccinesForm.module.scss';

interface PetVaccinesFormProps {
    petVaccines: Array<PetVaccine>;
    onChange?: (vaccines: PetVaccine[]) => void;
}

const createDefaultVaccines = (vaccines: Array<Option<string>>, petVaccines: Array<PetVaccine>) => {
    return vaccines.map(vaccine => {
        const petVaccine = petVaccines.find(v => v.type?.id === vaccine.id);

        if (petVaccine) {
            return {
                ...petVaccine,
                checked: true
            };
        }

        return {
            ...createEmptyVaccine(),
            checked: false,
            type: vaccine
        };
    });
};

export const PetVaccinesForm: React.FC<PetVaccinesFormProps> = ({ petVaccines, onChange }) => {
    const marketplace = useMarketplace();
    const [vaccines, setVaccines] = React.useState<Array<PetVaccine & { checked: boolean }>>(
        createDefaultVaccines(marketplace.vaccines, petVaccines)
    );

    const vaccineChangeHandler = (vaccine: PetVaccine & { checked: boolean }) => {
        const newVaccines = vaccines.map(v => {
            if (v.uuid === vaccine.uuid) {
                return { ...vaccine, checked: vaccine.checked };
            }

            return v;
        });

        setVaccines(newVaccines);
        onChange?.(newVaccines.filter(v => v.checked));
    };

    return (
        <div>
            <p className={classes.title}>
                <FontAwesomeIcon icon={faSyringe} />
                Vaccines records
            </p>

            {vaccines.map(vaccine => (
                <PetVaccineOption
                    key={vaccine.id}
                    vaccine={vaccine}
                    onChange={vaccineChangeHandler}
                />
            ))}
        </div>
    );
};
